import React, {FunctionComponent} from 'react'
import styles from './SearchPage.module.sass'
import SearchCard from '../../data-components/SearchCard/SearchCard'
import {useRootDispatch, useRootSelector} from '../../../utils/hooks'
import {isDefinedRecord, isDefinedTuple, pick} from '../../../utils/utils'
import {shallowEqual} from 'react-redux'
import {searchActions} from '../../../redux/pages/search'
import TopBarProgress from 'react-topbar-progress-indicator'
import {RequestStatus} from '../../../responses/response'
import {VirtuosoGrid} from 'react-virtuoso'
import {useUpdateEffect} from 'react-use'
import SearchFilters from './SearchFilters/SearchFilters'
import NotFound from '../../etc/NotFound/NotFound'

const SearchPage: FunctionComponent = () => {
    const {
        filters,
        results,
        status
    } = useRootSelector(state => pick(state.pages.search, 'filters', 'results', 'status'), shallowEqual)
    const dispatch = useRootDispatch()
    useUpdateEffect(() => {
        dispatch(searchActions.list.init(filters))
    }, [dispatch, filters])

    const isFiltersActive = isDefinedRecord(filters.dropdowns) || isDefinedTuple(filters.openedAt) || filters.search

    return <div className={styles.page}>
        {
            status === RequestStatus.FETCHING && <TopBarProgress/>
        }
        <SearchFilters/>
        {
            (results.length === 0 && status !== RequestStatus.FETCHING) && <div className={styles.error}>
                {
                    isFiltersActive ?
                        <NotFound
                            headerText='Ничего не найдено.'
                            infoText='Измените параметры поиска вверху страницы.'
                            imageName='EMPTY_1'
                        /> :
                        <NotFound
                            headerText='Нет объектов для отображения.'
                            infoText='Задайте параметры поиска вверху страницы.'
                            imageName='EMPTY_1'
                        />

                }
            </div>
        }
        <div className={styles.content}>
            <VirtuosoGrid
                className={styles.virtuoso}
                listClassName={styles.list}
                totalCount={results.length}
                itemContent={index => {
                    const result = results[index]
                    if (!result) {
                        console.warn('negative index', index)
                    }
                    return result ? <SearchCard result={result}/> :
                        <div>{index}</div>
                }}
                endReached={() => dispatch(searchActions.list.more())}
            />
        </div>
    </div>
}

export default SearchPage